/**
 * The form helper for handling validation of each individual registration step.
 * Handles the process of invalidating/validating multi-step forms by setting the
 * overall form as dirty as well as individual fields.
 */
App.factory('whoisHelper', [function() {
    var whoisHelper = {};

    /**
     * Handle resetting the whois telephone number field whenever the country code changes.
     */
    whoisHelper.resetPhoneField = function($scope, ngModel, elem, evt) {
        void 0;
        void 0;
        void 0;

        // update the whois field due to the new country code
        whoisHelper.setWhoisCountryCode($scope, ngModel);
    };

    /**
     * Handle updating the whois telephone number's placeholder value which generally
     * occurs when the country code changes.
     */
    whoisHelper.setWhoisCountryCode = function($scope, ngModel) {
        void 0;
        void 0;
        void 0;
        void 0;
        void 0;

        // return early if we're missing data
        if (!$scope.formData || !$scope.formData.whois_phone_countrycode) {
            void 0;
            return;
        }

        var country_code = $scope.formData.whois_phone_countrycode,
            phoneLib = i18n.phonenumbers.PhoneNumberUtil.getInstance(),
            result = phoneLib.getExampleNumberForType(country_code, i18n.phonenumbers.PhoneNumberType.MOBILE),
            key;

        // remove previous country code from formData.whois_phone
        if ($scope.formData.whois_phone) {
        	$scope.formData.whois_phone = $scope.formData.whois_phone.split(" ")[1];
        }

        // reset whois telephone countrycode numeric field
        $scope.formData.whois_phone_countrycode_numeric = '';

        // handle result to look for example number
        if (result != null && typeof result.values_ != 'undefined') {
            for (key in result.values_) {
                if (typeof result.values_[key] == 'number') {
                    // update the whois with the country code
                    $scope.formData.whois_phone = '+' + result.values_['1'] + ' ' + $scope.formData.whois_phone;

                    // break early
                    break;
                }
            }

            // set the numeric country code if available
            if (typeof result == 'object') {
                $scope.formData.whois_phone_countrycode_numeric = result.values_['1'];
            }
        }
    };

    /**
     * Handle enforcing the whois country code on the whois number text.
     */
    whoisHelper.enforceCountryCode = function($scope, ngModel, elem, evt) {
        var country_code = '+' + $scope.formData.whois_phone_countrycode_numeric;

        void 0;
        void 0;
        void 0;
        void 0;

        // remove previous country code from formData.whois_phone
        if ($scope.formData.whois_phone)
        	$scope.formData.whois_phone = $scope.formData.whois_phone.split(" ")[1];

        // if the element is currently shorter than the country code length, add it in
        if (!$scope.formData.whois_phone || ($scope.formData.whois_phone.length < country_code.length + 1)) {
            void 0;
            $scope.formData.whois_phone = country_code + ' ' + ($scope.formData.whois_phone ? $scope.formData.whois_phone : "");
            return false;
        }

        // if the element doesn't begin with the country code, add it in
        if ($scope.formData.whois_phone.indexOf(country_code) != 0) {
            void 0;
            $scope.formData.whois_phone = country_code + ' ' + ($scope.formData.whois_phone ? $scope.formData.whois_phone : "");
            return false;
        }

        return true;
    };

    /**
     * Handle validating the overall whois number text (toggling valid/invalid classes).
     */
    whoisHelper.validateText = function($scope, ngModel, elem, evt) {
        void 0;
        void 0;
        void 0;

        // if tab, do nothing
        if (evt.which == 9) {
            return true;
        }

        // next perform some more actionables
        return whoisHelper.isValidNumber(
            $scope.formData.whois_phone_countrycode,
            $scope.formData.whois_phone_countrycode_numeric,
            $scope.formData.whois_phone,
            $scope,
            ngModel
        );
    };

    /**
     * Validate if the number is indeed correct.
     */
    whoisHelper.isValidNumber = function(country, countryCode, input, $scope, ngModel) {
        void 0;
        void 0;
        void 0;
        void 0;

        var prettyPhone,
            countryForNumber,
            strippedPhone,
            splitNum,
            phoneLib,
            numberProto,
            country_code,
            p;

        // clear errors first
        $scope.whoisPhoneErrors = [];
        $scope.validWhoisPhone = false;

        country_code  = '+' + $scope.formData.whois_phone_countrycode_numeric + " ";

        // if no phone number, return early
        if (!input || input.length == country_code.length) {
            $scope.validWhoisPhone = false;
            ngModel.$setValidity('number', false);
        	$scope.whoisPhoneErrors.push("Your phone number is required for WHOIS.");
            return false;
        }

        // formatE164 and countryForE164Number methods in PhoneFormat.js
        prettyPhone = formatE164(country, cleanPhone(input));
        countryForNumber = countryForE164Number(prettyPhone);
        strippedPhone = prettyPhone.replace(/[^\d]/g, '');
        input = input.replace(/[^\d]/g,'');

        void 0;
        void 0;
        void 0;

        //no country code
        p = new RegExp('^' + countryCode);
        if (input.match(p) == null) {
            void 0;
            $scope.validWhoisPhone = false;
            ngModel.$setValidity('number', false);
            $scope.whoisPhoneErrors.push("The phone country code is invalid.");
            return false;
        }

        try {

            phoneLib = i18n.phonenumbers.PhoneNumberUtil.getInstance();
            numberProto = phoneLib.parse(input, country);

            if (!phoneLib.isValidNumber(numberProto)) {
                void 0;
                $scope.validWhoisPhone = false;
                ngModel.$setValidity('number', false);
            	$scope.whoisPhoneErrors.push("Your WHOIS phone number is invalid.");
            	return false;
            } else {
                $scope.validWhoisPhone = true;
                ngModel.$setValidity('number', true);
                $scope.whoisPhoneErrors = [];
            	return prettyPhone;
            }

        } catch (e) {
            $scope.validWhoisPhone = false;
            ngModel.$setValidity('number', false);
            $scope.whoisPhoneErrors.push("Your WHOIS phone number is invalid.");
            void 0;
        }

        return false;
    }

    return whoisHelper;
}]);
